import React from 'react'

import { Select } from '../..'
import { AnyProfile } from '../../../types'
import { Spacer } from '../../global'

import { ModalRow } from './styles'

const SelectRows = ({
  value,
  list,
  id,
  updateFn,
  showActiveBonus = false,
}: {
  value?: string
  list: AnyProfile[]
  id: 'idStudent' | 'teacher'
  updateFn: (e: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>) => void
  showActiveBonus?: boolean
}) => {
  return (
    <ModalRow>
      {id === 'idStudent' && <Spacer height={20} />}
      <div className="title">Selecciona un profesor</div>
      <Spacer height={13} />
      <Select
        list={list}
        value={value}
        name={id}
        defaultValue={`Selecciona un ${id === 'teacher' ? 'profesor' : 'Alumno'}`}
        handleSelectChange={updateFn}
        showActiveBonus={showActiveBonus}
      />
    </ModalRow>
  )
}

export default SelectRows
